export default __webpack_public_path__ + "static/media/service07.0715d50a.png";